import Component from "../../component";

export const NavbarConfig = {
    signature: 'navbar',
    baseHtmlClass: 'navbar',
    selector: '.navbar',
    initedHtmlClassModifier: 'inited',
    datasetConfigKey: 'navbar',
    identifierDatasetConfigKey: 'identifier',
};

export class Navbar extends Component {

    static applyToAll() {
        document.querySelectorAll(NavbarConfig.selector).forEach((element) => {
            if (!Navbar.isElementComponentized(element, NavbarConfig.signature)) new Navbar(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: NavbarConfig
        });

        this.setDatasetConfig(NavbarConfig.datasetConfigKey);

        // See https://developer.mozilla.org/en-US/docs/Web/Events/scroll
        this.lastScrollPosition = window.scrollY;
        this.tick = false;  // Track whether handleScroll call is currently in process.
        window.addEventListener('scroll', this.handleScroll.bind(this));

        this.inited = true;
        this.render();
    }

    handleScroll() {
        this.lastScrollPosition = window.scrollY;
        if (!this.tick) {
            window.requestAnimationFrame(()=>{
                this.render();
                this.tick = false;
            });
            this.tick = true;
        }

    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');
        this.conditionallySetHtmlClassState(this.isScrolledBeyondThreshold(), 'scrolled');
    }

    isScrolledBeyondThreshold() {
        return (this.lastScrollPosition > 200);
    }

}
